import { screenSizes } from '@shipt/design-system-themes'
import styled from 'styled-components'
import { Body, Headline, Link } from '@shipt/design-system-typography'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { Row } from '@shipt/design-system-layouts'

export const ContactInfo = () => {
  return (
    <GridLayoutContainer>
      <Row wrap padding={[0, 'md']} margin={[0, 0, 'xxl', 0]}>
        <ContactInfoBlock>
          <ContactInfoHeading as="h2">Support hours</ContactInfoHeading>
          <ContactInfoParagraph>Always Open 24/7</ContactInfoParagraph>
        </ContactInfoBlock>
        <ContactInfoBlock>
          <ContactInfoHeading as="h2">Get in touch</ContactInfoHeading>
          <ContactInfoParagraph>
            <Link href="mailto:support@shipt.com">support@shipt.com</Link>
          </ContactInfoParagraph>
          <ContactInfoParagraph>
            <Link href="tel:12055022500">(205) 502-2500</Link>
          </ContactInfoParagraph>
        </ContactInfoBlock>
        <ContactInfoBlock>
          <ContactInfoHeading as="h2">Offices</ContactInfoHeading>
          <ContactInfoParagraph>
            <strong>Birmingham</strong>
            <br />
            420 20th St N, Suite 100
            <br />
            Birmingham, AL 35203
          </ContactInfoParagraph>
          <ContactInfoParagraph>
            <strong>San Francisco</strong>
            <br />
            44 Montgomery Street
            <br />
            San Francisco, CA 94104
          </ContactInfoParagraph>
        </ContactInfoBlock>
      </Row>
    </GridLayoutContainer>
  )
}

const ContactInfoBlock = styled.div`
  margin-bottom: 2.5rem;
  text-align: center;
  width: 100%;

  @media ${screenSizes.tablet} {
    flex: 3;
  }
`

const ContactInfoHeading = styled(Headline)`
  margin-bottom: 0.75rem;
`

const ContactInfoParagraph = styled(Body)`
  margin-bottom: 1rem;
`
